import {h, Fragment} from "preact"
import { useState, useEffect } from "preact/hooks"
import { useSizeOptions, InfiniteScroll } from "@nosto/preact"
import { sizes, defaultConfig } from "../config"

import { wrapContent } from "./ContentWrapper"

import Breadcrumbs from "./Breadcrumbs"
import Toolbar from "./Toolbar"
import Header from "./Header"
import Sidebar from "./Sidebar"
import Products from "./Products"
import SizeGuide from "./SizeGuide"
import Pagination from "./Pagination"
import { SkeletonGrid } from "./Skeleton"
import NoResults from "./NoResults"

export function SerpBody({ loading, foundProducts }) {
    const { handleSizeChange } = useSizeOptions(sizes, defaultConfig.serpSize);
    const [ sidebarOpen, setSidebarOpen ] = useState(false);
    const [ sizeGuideOpen, setSizeGuideOpen ] = useState(false);
    const [ gridView, setGridView ] = useState(window.innerWidth < 1240 ? 2 : 4); // -1 | 4 | 2
    const pageSize = gridView > -1 ? defaultConfig.serpSize : sizes[3]

    useEffect(() => {
        if(window.innerWidth >= 1240) return;
        document.body.style.overflow = sidebarOpen ? 'hidden' : '';
        return () => document.body.style.overflow = '';
    }, [ sidebarOpen ])

    const handleGridViewChange = (newGridView) => {
        const newPageSize = newGridView > -1 ? defaultConfig.serpSize : sizes[3];
        setGridView(newGridView);
        if(pageSize === newPageSize) return;
        handleSizeChange(newPageSize);
    }

    return (
        <div
            class="ns-serp-body ns-flex ns-flex-col"
            data-filters={sidebarOpen}
            data-view={gridView}
        >
            <Breadcrumbs />
            <Toolbar
                handleGridViewChange={handleGridViewChange} 
                gridView={gridView}
            />
            <Header />
            <Sidebar
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
            />
            <div class="ns-w-100 ns-flex ns-flex-col">
                {foundProducts ? (
                    <>
                    <Products 
                        setSizeGuideOpen={setSizeGuideOpen}
                        gridView={gridView}
                    />
                    <Pagination />
                    </>
                ) : loading ? (
                    <SkeletonGrid />
                ) : (
                    <NoResults />
                )}
            </div>
            <SizeGuide 
                sizeGuideOpen={sizeGuideOpen}
                setSizeGuideOpen={setSizeGuideOpen}
            />
        </div>
    )
}

export function SerpBodyInfiniteScroll({ loading, foundProducts }) {
    const { handleSizeChange } = useSizeOptions(sizes, defaultConfig.serpSize);
    const [ sidebarOpen, setSidebarOpen ] = useState(false);
    const [ sizeGuideOpen, setSizeGuideOpen ] = useState(false);
    const [ gridView, setGridView ] = useState(window.innerWidth < 1240 ? 2 : 4); // -1 | 4 | 2
    const pageSize = gridView > -1 ? sizes[0] : window.innerWidth < 768 ? sizes[1]: sizes[3]

    useEffect(() => {
        if(window.innerWidth >= 1240) return;
        document.body.style.overflow = sidebarOpen ? 'hidden' : '';
        return () => document.body.style.overflow = '';
    }, [ sidebarOpen ])

    const handleGridViewChange = (newGridView) => {
        handleSizeChange(
            newGridView > -1
                ? sizes[0] // 24 default for 2 or 4 view
                : window.innerWidth < 768
                    ? sizes[1] // 36 mobile gallery
                    : sizes[3] // 54 desktop gallery
        );
        setGridView(newGridView);
    }

    return (
        <div 
            class="ns-serp-body ns-flex ns-flex-col"
            data-filters={sidebarOpen}
            data-view={gridView}
        >
            <Breadcrumbs />
            <Toolbar 
                handleGridViewChange={handleGridViewChange}
                gridView={gridView}
            />
            <Header />
            <Sidebar
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
            />
            <div class="ns-w-100 ns-flex ns-flex-col">
                {foundProducts ? (
                    <>
                    <InfiniteScroll pageSize={pageSize}>
                        <Products 
                            setSizeGuideOpen={setSizeGuideOpen}
                            gridView={gridView}
                        />
                    </InfiniteScroll>
                    </>
                ) : loading ? (
                    <SkeletonGrid />
                ) : (
                    <NoResults />
                )}
            </div>
            <SizeGuide 
                sizeGuideOpen={sizeGuideOpen}
                setSizeGuideOpen={setSizeGuideOpen}
            />
        </div>
    )
}

// replace with following line to enable infinite scroll
// export default wrapContent("search", SerpBodyInfiniteScroll)
export default wrapContent("search", SerpBody)
